import type { ProductMetaTag } from '#root/api/clients/product/data-contracts'
import type { FaqProductMetaTag, ProductFaq, StringProductMetaTag } from '#root/types/product'

/**
 * Type guard that checks whether a product meta tag has FAQ content
 *
 * @param tag The tag to check
 * @return True if has array content, false otherwise
 */
export const isFaqProductMetaTag = (tag: ProductMetaTag): tag is FaqProductMetaTag =>
  Array.isArray(tag.content)
  && tag.content.every((content) => 'q' in content && 'a' in content)

/**
 * Type guard that checks whether a product meta tag has string content (e.g. title)
 *
 * @param tag The tag to check
 * @return True if has string content, false otherwise
 */
export const isStringProductMetaTag = (tag: ProductMetaTag): tag is StringProductMetaTag => typeof tag.content === 'string'

/**
 * Extracts array content from a product meta tag
 *
 * @param tag The tag to get content from
 * @returns The string content, if available
 */
export const getProductMetaTagFaqValue = (tag?: ProductMetaTag): ProductFaq[] | undefined =>
  tag && isFaqProductMetaTag(tag) ? tag.content : undefined

/**
 * Extracts string contet from a product meta tag
 *
 * @param tag The tag to get content from
 * @returns The string content, if available
 */
export const getProductMetaTagStringValue = (tag?: ProductMetaTag): string | undefined =>
  tag && isStringProductMetaTag(tag) ? tag.content : undefined
